import type { RouteRecordRaw } from 'vue-router';
import { brandsRoutesDictionary } from './brands-routes.dictionary.ts';

export const brandsRoutesConfig: RouteRecordRaw = {
  ...brandsRoutesDictionary.brands.root,
  redirect: {
    name: brandsRoutesDictionary.brands.list.name,
  },
  children: [
    {
      ...brandsRoutesDictionary.brands.list,
      component: () => import('../pages/List/BrandsListPage.vue'),
    },
    {
      ...brandsRoutesDictionary.brands.detail,
      component: () => import('../pages/Detail/BrandDetailPage.vue'),
      props: true,
    },
    {
      ...brandsRoutesDictionary.brands.create,
      component: () => import('../pages/Create/CreateBrandPage.vue'),
    },
    {
      ...brandsRoutesDictionary.brands.edit,
      component: () => import('../pages/Edit/EditBrandPage.vue'),
      props: true,
    },
  ],
};
